import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading, suspended } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (suspended) {
    return <Navigate to="/suspended" replace />;
  }
  if (!user) {
    return <Navigate to="/welcome" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
